import { createDrawingView, DRAWING_VIEW_TYPES } from "./drawingView.schema";

export const PAPER_SIZES = {
  A4_LANDSCAPE: {
    id: "A4_LANDSCAPE",
    name: "A4 Landscape",
    widthMm: 297,
    heightMm: 210,
  },
  A3_LANDSCAPE: {
    id: "A3_LANDSCAPE",
    name: "A3 Landscape",
    widthMm: 420,
    heightMm: 297,
  },
};

export function createSheetViewport({
  id,
  viewId,
  title,
  xMm = 20,
  yMm = 20,
  widthMm = 160,
  heightMm = 90,
  locked = false,
} = {}) {
  return {
    id: id || `vp_${Date.now()}`,
    viewId,
    title: title || "Viewport",
    xMm,
    yMm,
    widthMm,
    heightMm,
    locked,
    cropEnabled: false,
  };
}

export function createDefaultDrawingDocument() {
  const frontView = createDrawingView({
  id: "view_front",
  name: "Front View",
  type: DRAWING_VIEW_TYPES.FRONT,
  cameraType: "orthographic",
  viewMode: "hiddenLine",
  scale: 20,
});

const topView = createDrawingView({
  id: "view_top",
  name: "Top View",
  type: DRAWING_VIEW_TYPES.TOP,
  cameraType: "orthographic",
  viewMode: "hiddenLine",
  scale: 20,
});

const rightView = createDrawingView({
  id: "view_right",
  name: "Right View",
  type: DRAWING_VIEW_TYPES.RIGHT,
  cameraType: "orthographic",
  viewMode: "hiddenLine",
  scale: 20,
});

const isoView = createDrawingView({
  id: "view_iso",
  name: "3D View",
  type: DRAWING_VIEW_TYPES.ISO,
  cameraType: "perspective",
  viewMode: "realistic",
  scale: null,
});

  return {
    version: 1,
    views: [frontView, topView, rightView, isoView],
    sheets: [
      {
        id: "sheet_A3_001",
        name: "Interior Documentation",
        paper: PAPER_SIZES.A3_LANDSCAPE,
        viewports: [
  createSheetViewport({
    id: "vp_front",
    viewId: "view_front",
    title: "FRONT VIEW",
    xMm: 15,
    yMm: 20,
    widthMm: 180,
    heightMm: 85,
  }),
  createSheetViewport({
    id: "vp_top",
    viewId: "view_top",
    title: "TOP VIEW",
    xMm: 15,
    yMm: 115,
    widthMm: 180,
    heightMm: 80,
  }),
  createSheetViewport({
    id: "vp_right",
    viewId: "view_right",
    title: "RIGHT VIEW",
    xMm: 210,
    yMm: 20,
    widthMm: 80,
    heightMm: 85,
  }),
  createSheetViewport({
    id: "vp_iso",
    viewId: "view_iso",
    title: "3D VIEW",
    xMm: 300,
    yMm: 20,
    widthMm: 95,
    heightMm: 95,
  }),
],
        annotations: [],
        titleBlock: {
          projectName: "Interior Project",
          drawingNumber: "A-001",
          revision: "P01",
          scale: "As indicated",
          date: new Date().toISOString().slice(0, 10),
        },
      },
    ],
    activeSheetId: "sheet_A3_001",
  };
}